/**
 * Adopted from Svelte JS (https://github.com/sveltejs/svelte)
 * release `svelte@4.2.19` under the MIT License.
 */

/** @returns {void} */
export function noop() {}

/**
 * @param {Function} fn
 */
export function run(fn) {
	return fn();
}

/**
 * @param {Function[]} fns
 * @returns {void}
 */
export function run_all(fns) {
	fns.forEach(run);
}

/**
 * @param {any} thing
 * @returns {thing is Function}
 */
export function is_function(thing) {
	return typeof thing === 'function';
}

/**
 * @param {any} a
 * @param {any} b
 * @returns {boolean}
 */
export function safe_not_equal(a, b) {
	return a != a ? b == b : a !== b || (a && typeof a === 'object') || typeof a === 'function';
}

/**
 * 
 * @param {any} store 
 * @param  {...Function} callbacks 
 * @returns 
 */
export function subscribe(store, ...callbacks) {
	if (store == null) {
		for (const callback of callbacks) {
			callback(undefined);
		}
		return noop;
	}
	const unsub = store.subscribe(...callbacks);
	return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
}

/**
 * Get the current value from a store by subscribing and immediately unsubscribing.
 *
 * https://svelte.dev/docs/svelte-store#get
 * @template T
 * @param {import('./public.js').Readable<T>} store
 * @returns {T}
 */
export function get_store_value(store) {
	let value;
	subscribe(store, (/** @type {T} */ _) => (value = _))();
	return /** @type {T} */ (value);
}
